//ユーザーCSVアップロードページ
import React, { Fragment, useState, useRef, useEffect } from 'react';
import {
  Typography,
  Button,
  Form,
  message,
  Input,
  Select,
  Upload,
  Tag,
  theme,
  Progress,
  Modal,
  Spin,
} from 'antd';
import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { TweenOneGroup } from 'rc-tween-one';
import Axios from 'axios';
const { Option } = Select;
const { TextArea } = Input;
const { Title, Text } = Typography;

function VideoEditPage(props) {
  const { token } = theme.useToken();
  const [tags, setTags] = useState([]);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);
  const [videoCategory, setVideoCategory] = useState([]); //グループ名とグループコード
  const [instructor, setInstructor] = useState([]); //グループにあるサーベイシーズン
  const [value, setValue] = useState('');
  // 動画・サムネール差し替え用（未選択なら既存のまま維持）
  const [videoFileList, setVideoFileList] = useState([]);
  const [thumbnailList, setThumbnailList] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);
  // 動画カテゴリ新規登録モーダル用
  const [categoryModalVisible, setCategoryModalVisible] = useState(false);
  const [newCategory, setNewCategory] = useState({
    category_name: '',
    category_description: '',
  });
  const { user } = props;
  const vdInfo = props.location.state;

  const readDB = async () => {
    try {
      if (!user.userData) return null;
      // console.log(user.userData.isAuth);
      if (user.userData.isAuth) {
        // const [vc, inst] = await Promise.all([
        //   Axios.get('/api/videoCategory/'),
        //   Axios.get('/api/instructor/'),
        // ]);
        const vc = await Axios.get('/api/videoCategory/');
        const inst = await Axios.get('/api/instructor/');
        // console.log(vc.data.videoCategory);
        // console.log(inst.data.instructor);
        if (vc.data.success && inst.data.success) {
          setVideoCategory(vc.data.videoCategory);
          setInstructor(inst.data.instructor);
        } else {
          throw new Error('ビデオカテゴリ取得に失敗しました。');
        }
      } else {
        throw new Error('ログイン前です。');
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // if (!user.userData) return null;
    readDB();
    // console.log({ vdInfo });
    setValue({
      videoName: vdInfo.title,
      videoCategory: vdInfo.category_code_id._id,
      duration_h: vdInfo.duration_h,
      duration_m: vdInfo.duration_m,
      duration_s: vdInfo.duration_s,
      instructor: vdInfo.instructor._id,
      videoExplanation: vdInfo.video_explanation,
      videoDescription: vdInfo.video_description,
      thumbnail: vdInfo.thumbnail[0],
    });
    setTags(vdInfo.tag);

    if (inputVisible) {
      inputRef.current.focus();
    }
  }, [user]);

  // 動画ファイル選択（1個・差し替え用）。選択時に再生時間を自動取得して duration を埋める。
  const uploadVideoFile = {
    onRemove: () => {
      setVideoFileList([]);
    },
    beforeUpload: (file) => {
      // .mp4 のみ許可（選択ミス防止）。type が空でも拡張子で判定する。
      const isMp4 =
        file.type === 'video/mp4' || file.name.toLowerCase().endsWith('.mp4');
      if (!isMp4) {
        message.error('動画は .mp4 ファイルのみ選択できます。');
        return Upload.LIST_IGNORE;
      }
      setVideoFileList([file]);

      // 動画の再生時間を自動取得
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.onloadedmetadata = () => {
        const duration = Math.floor(video.duration);
        const hours = Math.floor(duration / 3600);
        const minutes = Math.floor((duration % 3600) / 60);
        const seconds = duration % 60;
        setValue((prev) => ({
          ...prev,
          duration_h: hours.toString(),
          duration_m: minutes.toString(),
          duration_s: seconds.toString(),
        }));
      };
      video.onerror = () => {
        console.log('動画のメタデータ読み取りに失敗しました');
      };
      video.src = URL.createObjectURL(file);

      return false; // 自動アップロードを抑止（送信は onSubmit で実施）
    },
    fileList: videoFileList,
  };

  // サムネール選択（1個・差し替え用）
  const uploadThumbnail = {
    onRemove: () => {
      setThumbnailList([]);
    },
    beforeUpload: (file) => {
      // .jpg / .jpeg / .png のみ許可（選択ミス防止）。type が空でも拡張子で判定する。
      const isImage =
        ['image/jpeg', 'image/png'].includes(file.type) ||
        /\.(jpg|jpeg|png)$/i.test(file.name);
      if (!isImage) {
        message.error('サムネールは .jpg / .jpeg / .png ファイルのみ選択できます。');
        return Upload.LIST_IGNORE;
      }
      setThumbnailList([file]);
      return false;
    },
    fileList: thumbnailList,
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      if (!value.instructor || !value.videoName || !value.videoCategory)
        throw new Error('必須項目が入力されていません');

      const hasNewVideo = videoFileList.length > 0;
      const hasNewThumbnail = thumbnailList.length > 0;

      message.loading({
        content: '動画情報保存中...',
        key: 'videoedit',
        duration: 0,
      });

      // Step 1: 動画差し替え（新しい動画が選択された場合のみ）
      // Vimeo の URI は差し替え後も不変。サムネール S3 パスもこの URI 基準で維持される。
      let vimeoUri = vdInfo.url;
      if (hasNewVideo) {
        setUploadProgress(0);
        setModalVisible(true);
        const formData = new FormData();
        formData.append('video', videoFileList[0]);
        const upRes = await Axios.post(
          `/api/video/${vdInfo._id}/upload`,
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
            onUploadProgress: (e) => {
              if (e.total) {
                setUploadProgress(((e.loaded / e.total) * 100).toFixed(2));
              }
            },
          }
        );
        if (!upRes.data.success) {
          throw new Error(upRes.data.error || '動画の差し替えに失敗しました。');
        }
        vimeoUri = upRes.data.uri; // 同一 URI が返る
        setModalVisible(false);
      }

      // Step 2: サムネール差し替え（新しいサムネールが選択された場合のみ）
      let newThumbnail = null;
      if (hasNewThumbnail) {
        const presignedResponse = await Axios.post(
          '/api/presignedUrl/thumbnail',
          {
            fileName: thumbnailList[0].name,
            fileType: thumbnailList[0].type,
            fileSize: thumbnailList[0].size,
            vimeoUri: vimeoUri,
          }
        );
        if (!presignedResponse.data.success) {
          throw new Error(
            presignedResponse.data.error || 'サムネールURL取得に失敗しました。'
          );
        }
        const putResponse = await fetch(presignedResponse.data.uploadUrl, {
          method: 'PUT',
          body: thumbnailList[0],
          headers: { 'Content-Type': thumbnailList[0].type },
        });
        if (!putResponse.ok) {
          throw new Error(
            `サムネールアップロードに失敗しました: ${putResponse.statusText}`
          );
        }
        newThumbnail = presignedResponse.data.fileUrl;
      }

      // Step 3: メタデータ（+差し替えた場合はサムネール）を保存
      const sendData = {
        title: value.videoName,
        tag: tags,
        category_code_id: value.videoCategory,
        video_description: value.videoDescription,
        video_explanation: value.videoExplanation,
        instructor: value.instructor,
        duration_h: value.duration_h,
        duration_m: value.duration_m,
        duration_s: value.duration_s,
      };
      // サムネールを差し替えた場合のみ thumbnail を送る（サーバーが旧 S3 を掃除）
      if (newThumbnail) sendData.thumbnail = [newThumbnail];

      const res = await Axios.patch(`/api/video/${vdInfo._id}`, sendData);

      if (res.data.success) {
        message.success({
          content: '動画情報を保存しました。',
          key: 'videoedit',
          duration: 2,
        });
        setTimeout(() => {
          props.history.push('/videomgr');
        }, 1000);
      } else {
        throw new Error('動画情報の保存に失敗しました。');
      }
    } catch (error) {
      const serverMsg = error.response?.data?.error;
      console.log({ error, serverMsg });
      setModalVisible(false);
      message.error({
        content: serverMsg || error.message,
        key: 'videoedit',
        duration: 5,
      });
    }
  };

  const onChangeVideoName = (e) => {
    setValue({ ...value, videoName: e.currentTarget.value });
    // console.log(value);
  };
  const onChangeDuration_h = (e) => {
    setValue({ ...value, duration_h: e.currentTarget.value });
  };
  const onChangeDuration_m = (e) => {
    setValue({ ...value, duration_m: e.currentTarget.value });
  };
  const onChangeDuration_s = (e) => {
    setValue({ ...value, duration_s: e.currentTarget.value });
  };
  const onChangeExpl = (e) => {
    setValue({ ...value, videoExplanation: e.currentTarget.value });
    // console.log(value);
  };
  const onChangeDesc = (e) => {
    setValue({ ...value, videoDescription: e.currentTarget.value });
    // console.log(value);
  };

  const onChangeVideoCategory = (v) => {
    setValue({ ...value, videoCategory: v });
  };

  const onChangeInstructor = (v) => {
    setValue({ ...value, instructor: v });
  };

  // 新規動画カテゴリ登録（category_code はサーバー側で自動採番）
  const handleAddCategory = async () => {
    try {
      if (!newCategory.category_name) {
        message.error('カテゴリ名は必須です');
        return;
      }
      const res = await Axios.post('/api/videoCategory/', newCategory);
      if (res.data.success) {
        message.success('カテゴリを登録しました');
        // カテゴリリストを再読み込み
        const vc = await Axios.get('/api/videoCategory/');
        if (vc.data.success) {
          setVideoCategory(vc.data.videoCategory);
          // 新規登録したカテゴリを自動選択
          setValue({ ...value, videoCategory: res.data.videoCategory._id });
        }
        setCategoryModalVisible(false);
        setNewCategory({ category_name: '', category_description: '' });
      }
    } catch (error) {
      console.log(error);
      message.error('カテゴリ登録に失敗しました');
    }
  };

  const handleClose = (removedTag) => {
    const newTags = tags.filter((tag) => tag !== removedTag);
    // console.log(newTags);
    setTags(newTags);
  };
  const showInput = () => {
    setInputVisible(true);
  };
  const handleInputChange = (e) => {
    // console.log(e.target.value);
    setInputValue(e.target.value);
  };
  const handleInputConfirm = () => {
    if (inputValue && tags.indexOf(inputValue) === -1) {
      setTags([...tags, inputValue]);
    }
    setInputVisible(false);
    setInputValue('');
  };
  const forMap = (tag) => {
    const tagElem = (
      <Tag
        closable
        onClose={(e) => {
          e.preventDefault();
          handleClose(tag);
        }}
      >
        {tag}
      </Tag>
    );
    return (
      <span
        key={tag}
        style={{
          display: 'inline-block',
        }}
      >
        {tagElem}
      </span>
    );
  };
  const tagChild = tags.map(forMap);
  const tagPlusStyle = {
    background: token.colorBgContainer,
    borderStyle: 'dashed',
  };

  return (
    <Fragment>
      <div style={{ maxWidth: '700px', margin: '2rem auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Title level={2}>動画情報編集</Title>
        </div>
        <Form onSubmit={onSubmit}>
          <br />

          <div>
            <br />
            <Text strong>■ 動画差し替え（任意）</Text>
            <div style={{ marginTop: 8 }}>
              <Upload {...uploadVideoFile} maxCount={1} accept=".mp4">
                <Button icon={<UploadOutlined />}>動画ファイル選択</Button>
              </Upload>
              <Text type="secondary">
                動画を選択しない場合は既存の動画が維持されます。差し替えると同じ動画URLのまま中身のみ更新されます。
              </Text>
            </div>
          </div>

          <div>
            <br />
            <Text strong>■ 動画名（必須）</Text>
            <div
              style={{ display: 'flex', justifyContent: 'space-between' }}
            ></div>
            <Input
              placeholder="動画名（必須）"
              name="mt_name"
              allowClear
              onChange={onChangeVideoName}
              value={value['videoName']}
            />
          </div>
          <div>
            <br />
            <Text strong>■ サムネール</Text>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <img
                style={{ width: '320px' }}
                alt="サムネール"
                border={'2'}
                src={value['thumbnail']}
              />
            </div>
            <div style={{ marginTop: 8 }}>
              <Upload {...uploadThumbnail} maxCount={1} accept=".jpg,.jpeg,.png">
                <Button icon={<UploadOutlined />}>サムネール差し替え</Button>
              </Upload>
              <Text type="secondary">
                サムネールを選択しない場合は既存のものが維持されます。差し替えると旧サムネールは削除されます（JPEG / PNG）。
              </Text>
            </div>
          </div>
          <div>
            <br />
            <Text strong>■ 再生時間（必須）</Text>
            <br />
            <Input
              style={{ marginLeft: 0, marginRight: 10, width: 80 }}
              placeholder="時間"
              name="duration_h"
              allowClear
              onChange={onChangeDuration_h}
              value={value['duration_h']}
            />
            時間　
            <Input
              style={{ marginLeft: 0, marginRight: 10, width: 80 }}
              placeholder="分"
              name="duration_m"
              allowClear
              onChange={onChangeDuration_m}
              value={value['duration_m']}
            />
            分　
            <Input
              style={{ marginLeft: 0, marginRight: 10, width: 80 }}
              placeholder="秒"
              name="duration_m"
              allowClear
              onChange={onChangeDuration_s}
              value={value['duration_s']}
            />
            秒
          </div>
          <div>
            <br />
            <Text strong>■ 動画カテゴリ選択（必須）</Text>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Select
                showSearch
                style={{ marginLeft: 0, marginRight: 10, width: 300 }}
                placeholder="動画カテゴリ選択"
                optionFilterProp="children"
                onChange={onChangeVideoCategory}
                value={value['videoCategory']}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {videoCategory.map((element) => {
                  return (
                    <Option value={element._id} key={element._id}>
                      {element.category_name}
                    </Option>
                  );
                })}
              </Select>
              <Button
                icon={<PlusOutlined />}
                onClick={() => setCategoryModalVisible(true)}
              >
                新規登録
              </Button>
            </div>
          </div>
          <div>
            <br />
            <Text strong>■ 講師選択（必須）</Text>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Select
                showSearch
                style={{ marginLeft: 0, marginRight: 10, width: 300 }}
                placeholder="講師選択"
                optionFilterProp="children"
                onChange={onChangeInstructor}
                value={value['instructor']}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {instructor.map((element) => {
                  return (
                    <Option value={element._id} key={element._id}>
                      {element.name}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </div>
          <div>
            <br />
            <Text strong>■ 動画タイトル：ユーザ向け（表示用）</Text>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <TextArea
                rows={3}
                onChange={onChangeExpl}
                value={value['videoExplanation']}
              />
            </div>
          </div>
          <div>
            <br />
            <Text strong>■ 動画説明：管理向け</Text>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <TextArea
                rows={3}
                onChange={onChangeDesc}
                value={value['videoDescription']}
              />
            </div>
          </div>

          <div>
            <br />
            <Text strong>■ Tag記入</Text>
            {/* <div style={{ display: 'flex', justifyContent: 'space-between' }}> */}
            <div
              style={{
                marginBottom: 16,
              }}
            >
              <TweenOneGroup
                enter={{
                  scale: 0.8,
                  opacity: 0,
                  type: 'from',
                  duration: 100,
                }}
                onEnd={(e) => {
                  if (e.type === 'appear' || e.type === 'enter') {
                    e.target.style = 'display: inline-block';
                  }
                }}
                leave={{
                  opacity: 0,
                  width: 0,
                  scale: 0,
                  duration: 200,
                }}
                appear={false}
              >
                {tagChild}
              </TweenOneGroup>
            </div>
            <div>
              {inputVisible ? (
                <Input
                  ref={inputRef}
                  type="text"
                  size="small"
                  style={{
                    width: 78,
                  }}
                  value={inputValue}
                  onChange={handleInputChange}
                  onBlur={handleInputConfirm}
                  onPressEnter={handleInputConfirm}
                />
              ) : (
                <Tag onClick={showInput} style={tagPlusStyle}>
                  <PlusOutlined /> New Tag
                </Tag>
              )}
            </div>
          </div>

          <Button
            type="primary"
            onClick={onSubmit}
            disabled={
              value['videoName'] === '' || value['videoCategory'] === ''
            }
            size="large"
            style={{
              marginTop: 16,
            }}
          >
            動画情報保存
          </Button>
        </Form>
        <Modal
          title="動画差し替え中"
          open={modalVisible}
          closable={false}
          maskClosable={false}
          footer={null}
        >
          <div
            style={{
              height: '12em',
              position: 'relative',
            }}
          >
            <div
              style={{
                margin: '0',
                height: '10em',
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
              }}
            >
              {uploadProgress < 100 ? (
                <>
                  アップロード中...
                  <br />
                  <br />
                  <Progress type="circle" percent={Number(uploadProgress)} />
                </>
              ) : (
                // 転送完了（100%）後も Vimeo 側の処理完了を待つ。
                // 静止した 100% 円だとフリーズに見えるため、スピナー + 待機案内を表示する。
                <>
                  Vimeo処理中...
                  <br />
                  動画を差し替えています。
                  <br />
                  画面を閉じずにしばらくお待ちください。
                  <br />
                  <br />
                  <Spin size="large" />
                </>
              )}
            </div>
          </div>
        </Modal>
        <Modal
          title="動画カテゴリ新規登録"
          open={categoryModalVisible}
          onOk={handleAddCategory}
          onCancel={() => {
            setCategoryModalVisible(false);
            setNewCategory({ category_name: '', category_description: '' });
          }}
          okText="登録"
          cancelText="キャンセル"
        >
          <div style={{ marginBottom: 16 }}>
            <Text strong>カテゴリ名（必須）</Text>
            <Input
              placeholder="カテゴリ名"
              value={newCategory.category_name}
              onChange={(e) =>
                setNewCategory({ ...newCategory, category_name: e.target.value })
              }
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <Text strong>説明</Text>
            <Input
              placeholder="説明"
              value={newCategory.category_description}
              onChange={(e) =>
                setNewCategory({
                  ...newCategory,
                  category_description: e.target.value,
                })
              }
            />
          </div>
        </Modal>
      </div>
    </Fragment>
  );
}

export default VideoEditPage;
